<template>
    <div class="wallet-connect">
        <button
            v-if="!hasWallet"
            class="admin-btn admin-btn-primary"
            type="button"
            style="padding: 0 8px; margin: auto"
            @click="showWallet"
        >
            Connect Wallet
        </button>
        <button
            v-else
            class="admin-wlt-dtl admin-btn admin-btn-primary"
            type="button"
            style="line-height: 1 !important"
            @click="showOnWallet"
        >
            <div style="margin: auto">{{ balanceStr }} {{ tokenText }}</div>
            <div class="admin-adr-wlt">{{ slicedAddress }}</div>
        </button>
        <b-modal
            ref="connect-wallet"
            centered
            hide-footer
            title="Select a Wallet"
        >
            <a
                v-if="!checkMetamask"
                ref="install-metamask"
                @click="InstallMetamask()"
            >
                <div class="box-wallet mb-3">
                    <div class="text-wallet">Install Metamask</div>
                    <img src="/icon/metamask.png" alt="" class="img-wallet" />
                </div>
            </a>
            <a v-else ref="connect-metamask" @click="getAccount()">
                <div class="box-wallet mb-3">
                    <div class="text-wallet">Connect Metamask</div>
                    <img src="/icon/metamask.png" alt="" class="img-wallet" />
                </div>
            </a>
            <div class="d-flex flex-column text-center">
                <div class="txt-btm-wlt">New to Ethereum?</div>
                <div class="txt-btm-wlt text-blue">
                    <a :href="'https://metamask.io/'" target="_blank">
                        Learn more about wallet
                    </a>
                </div>
            </div>
        </b-modal>
        <b-modal ref="wallet-on" centered hide-footer title="Account">
            <div class="box-onwallet">
                <div class="title-box-1">Connected with MetaMask</div>
                <div class="subtitle-box">
                    <a @click="logOut()" style="cursor: pointer">
                        Logout
                    </a>
                </div>
            </div>
            <div class="box-onwallet-2">
                <input
                    type="text"
                    class="form-control"
                    v-model="slicedAddress"
                    ref="myAdd"
                    aria-label=""
                    aria-describedby=""
                    disabled
                />
                <input
                    type="hidden"
                    id="wallet-input"
                    class="form-control"
                    :value="walletAddress"
                />
            </div>
            <div class="box-onwallet-2">
                <a
                    :href="
                        getTokenUrl($store.state.wallet.selectedNetwork) +
                            '/address/' +
                            walletAddress
                    "
                    target="_blank"
                >
                    <div class="tle-box-1">View on explorer</div>
                </a>
                <div
                    class="tle-box-1"
                    style="cursor: pointer"
                    @click="copyAddress"
                >
                    Copy Address
                </div>
                <div v-if="copied" class="copy-ad">Copied</div>
            </div>
        </b-modal>
        <b-modal ref="network-alert" centered hide-footer title="Network Alert">
            <div class="d-flex flex-column text-center">
                <div class="txt-btm-wlt">
                    <!-- Theta Nuts only supports Ethereum and BSC Mainnet. Please
                    change the network in your wallet to proceed -->
                    You are connected to an unsupported network on your wallet.
                    Please change the network in your wallet to proceed.
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            copied: false
        };
    },
    computed: {
        ...mapGetters({
            hasWallet: "wallet/getHasWallet",
            checkMetamask: "wallet/getCheckMetamask",
            balance: "wallet/getBalance",
            walletAddress: "wallet/getAddress",
            slicedAddress: "wallet/getSlicedAddress",
            selectedNetwork: "wallet/getSelectedNetwork",
            tokenText: "wallet/getTokenText",
            showNetworkAlert: "vaults/getShowNetworkAlert"
        }),
        balanceStr() {
            return parseFloat(this.balance).toFixed(6);
        }
    },
    watch: {
        showNetworkAlert(newShowNetworkAlert, oldShowNetworkAlert) {
            if (newShowNetworkAlert == true) {
                this.hideAllPopup();
                this.$refs["network-alert"].show();
                this.$store.commit("vaults/setShowNetworkAlert", false);
            }
        }
    },
    mounted() {},
    methods: {
        ...mapActions({
            clearWalletStatus: "wallet/clearWalletStatus",
            connectWithMetamask: "wallet/connectWithMetamask"
        }),
        async getAccount() {
            await this.connectWithMetamask();
            this.$refs["connect-wallet"].hide();
        },
        logOut() {
            // logout metamask
            this.clearWalletStatus();
            this.$refs["wallet-on"].hide();
        },
        InstallMetamask() {
            window.open("https://metamask.io/download.html");
        },
        async showWallet() {
            if (!this.checkMetamask) {
                this.$refs["connect-wallet"].show();
            } else {
                const MetamaskAccount = await ethereum.request({
                    method: "eth_accounts"
                });
                if (MetamaskAccount["length"] === 0) {
                    //
                    this.$refs["connect-wallet"].show();
                } else {
                    await this.connectWithMetamask();
                }
            }
        },
        showOnWallet() {
            this.$refs["wallet-on"].show();
        },
        hideAllPopup() {
            this.$refs["wallet-on"].hide();
            this.$refs["connect-wallet"].hide();
        },
        copyAddress() {
            this.copied = true;
            let copyAdrWallet = document.querySelector("#wallet-input");
            copyAdrWallet.setAttribute("type", "text");
            copyAdrWallet.select();
            document.execCommand("copy");

            copyAdrWallet.setAttribute("type", "hidden");
            window.getSelection().removeAllRanges();
            setTimeout(() => {
                this.copied = false;
            }, 1000);
        }
    }
};
</script>

<style lang="scss">
@import "./resources/sass/_variables.scss";
.admin-btn {
    font-family: "Bungee";
    font-style: normal;
    font-weight: normal;
    // font-size: 14px;
    // font-size: 0.97222vw; //$text-normal;
    min-height: 35px;
    max-height: 55px;
    width: 200px;
    line-height: 0vmax !important;
    text-align: center;
    color: $primary-4 !important;
    padding: 0 !important;
    border-radius: 20px !important;

    &.admin-btn-primary {
        border: none;
        border-color: #27ae60;
        background: #27ae60;

        &:hover {
            border-color: #27ae60;
            background: linear-gradient(
                    0deg,
                    rgba(255, 255, 255, 0.05),
                    rgba(255, 255, 255, 0.05)
                ),
                #27ae60;
            box-shadow: 2px 3px 6px rgba(42, 207, 59, 0.3);
        }

        &:focus {
            border-color: #27ae60;
            background: linear-gradient(
                    0deg,
                    rgba(255, 255, 255, 0.3),
                    rgba(255, 255, 255, 0.3)
                ),
                #27ae60;
            box-shadow: 3px 5px 10px rgba(42, 207, 59, 0.3);
        }

        &:disabled {
            opacity: 0.8;
            border-color: #7c7c7c;
            background: #7c7c7c;
        }
    }

    &.admin-btn-secondary {
        position: relative;
        border-color: transparent;
        background: $gradient-2;
        box-shadow: 3px 5px 10px rgba(64, 149, 197, 0.3);
        z-index: 1;

        &:before {
            content: "";
            position: absolute;
            left: 1px;
            right: 1px;
            top: 1px;
            bottom: 1px;
            z-index: -1;
            background: #1d1d1d;
            border-radius: 20px !important;
        }

        &:hover {
            &:before {
                background: rgba(29, 29, 29, 0.9);
            }
        }

        &:focus {
            &:before {
                background: rgba(29, 29, 29, 0.6);
            }
        }

        &:disabled {
            opacity: 0.8;
            border-color: #7c7c7c;
            background: #7c7c7c;
            color: #7c7c7c !important;
        }
    }
}

.form-control,
.form-control:active,
.form-control:focus,
.form-control:disabled {
    background: #232121;
    border: none;
    //border-radius: 0.9vmax;
    color: #fff;
    width: 100%;
    //font-size: 0.9vmax;
    //padding: 1.5% 3%;
    //height: 3.138vh;
    font-size: 0.90278vw;
    line-height: 1.319445vw;
    border-radius: 0.90278vw;
    padding: 0.416667vw 0.83333vw;
    height: 1.945vw;

    @media only screen and (min-width: 1440px) {
        font-size: 0.90278vw;
        line-height: 1.319445vw;
        border-radius: 0.90278vw;
        padding: 0.416667vw 0.83333vw;
        height: 1.945vw;
    }

    &::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #9c9c9c;
        opacity: 1; /* Firefox */
    }

    &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #9c9c9c;
    }

    &::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #9c9c9c;
    }
}
.admin-wlt-dtl {
    padding: 0px 8px !important;
    margin: auto;
    display: flex;
    justify-content: space-between;
    width: 300px !important;
    // margin-right: -2.70833vw;
    .admin-adr-wlt {
        --tw-bg-opacity: 0.5;
        background-color: rgba(32, 34, 49, var(--tw-bg-opacity));
        margin: auto;
        height: 10px;
        border-radius: 1vmax;
        padding: 10px 8px;
        font-family: Exo;
        font-style: normal;
        font-weight: normal;
        // font-size: 0.764vw;
        line-height: 0;
        margin-left: 3%;
    }
}
.box-onwallet-2 {
    display: flex;
    justify-content: left;
    font-family: Exo;
    font-style: normal;
    margin-bottom: 20px;
    gap: 20px;
    position: relative;
    .copy-ad {
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        color: #ffffff;
        padding: 5px;
        border: 1px solid #ffffff;
        position: absolute;
        bottom: 59%;
        right: 27%;
        background: #000000;
        border-radius: 4px;
    }
    .tle-box-1 {
        font-weight: normal;
        font-size: 1vmax;
        line-height: 1.2vmax;
        color: $primary-1;
        margin: auto 0;

        @media only screen and (min-width: 1440px) {
            font-size: 16px;
            line-height: 20px;
        }
    }
    a,
    a:hover {
        text-decoration: none !important;
    }
}
.box-onwallet {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: start;
    align-items: flex-start;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-family: Exo;
    font-style: normal;
    margin-bottom: 20px;

    .title-box-1 {
        font-weight: bold;
        font-size: 1.1vmax;
        line-height: 1.5vmax;
        color: $primary-4;
        opacity: 0.8;
        margin: auto 0;

        @media only screen and (min-width: 1440px) {
            font-size: 18px;
            line-height: 24px;
        }
    }

    .title-box-2 {
        font-weight: bolder;
        font-size: 16px;
        line-height: 1.5vmax;
        color: $primary-4;
        margin: auto 0;
    }
    .subtitle-box {
        font-weight: normal;
        font-size: 0.9vmax;
        line-height: 1.5vmax;
        color: $primary-4;
        margin: auto 0;

        @media only screen and (min-width: 1440px) {
            font-size: 15px;
            line-height: 25px;
        }
    }
}
.box-wallet-wrapper {
    padding-bottom: 15px;

    &:not(:first-child) {
        padding: 15px 0;
    }

    &:not(:last-of-type) {
        border-bottom: 1px solid rgba(207, 207, 207, 0.5);

        @media only screen and (min-width: 1440px) {
            border-bottom: 0.06944444444444445vw solid rgba(207, 207, 207, 0.5);
        }
    }
}
.box-wallet {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: start;
    align-items: flex-start;
    -ms-flex-pack: justify;
    justify-content: space-between;
    width: 100%;
    --tw-bg-opacity: 1;
    background-color: rgba(32, 34, 49, var(--tw-bg-opacity));
    border-radius: 0.3vmax;
    min-height: 50px;
    height: 6.16vh;
    padding: 0 1.2rem;
    cursor: pointer;
    flex-direction: column;
    border-radius: 10px;

    .box-wallet__title {
        font-family: Sofia Sans;
        font-size: 24px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: center;
        margin-top: 10px;
    }
    .box-wallet__subtitle {
        font-family: Sofia Sans;
        font-size: 16px;
        font-weight: 300;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: center;
        margin-top: 10px;
    }

    @media only screen and (min-width: 1440px) {
        height: 50px;
        padding: 0 19px;
    }

    .text-wallet {
        font-family: Exo;
        font-style: normal;
        font-weight: bold;
        font-size: 1.2vmax;
        line-height: 1.5vmax;
        color: $primary-4;
        margin: auto 0;

        @media only screen and (min-width: 1440px) {
            font-size: 17px;
            line-height: 21px;
        }
    }
    .img-wallet {
        margin: auto 0;
        width: 2.223vw;
        height: 3.453vh;

        @media only screen and (min-width: 1440px) {
            width: 32px;
            height: 28px;
        }
    }
}
.txt-btm-wlt {
    font-family: Exo;
    font-style: normal;
    font-weight: normal;
    font-size: 1vmax;
    line-height: 1.4vmax;
    color: $primary-4;
    margin: auto 0;
    text-align: left;
    @media only screen and (min-width: 1440px) {
        /* font-size: 14px;
    line-height: 20px; */
        font-size: 0.9722222222222222vw;
        line-height: 1.3888888888888888vw;
    }
}
.text-blue {
    --tw-text-opacity: 1;
    color: rgba(9, 147, 236, var(--tw-text-opacity)) !important;
}
.modal-backdrop {
    opacity: 0.5;
}
.modal-dialog {
    width: 31.25vw;

    @media only screen and (min-width: 1440px) {
        max-width: initial;
    }
}
.modal-body {
    padding: 3.7%;
}
.modal-content {
    border-radius: 10px;
    border: 1px solid $primary-1;
    box-shadow: 1px 3px 15px 1px rgba(110, 226, 159, 0.15);
    background: #000000;
    opacity: 1;
    padding: 0 0.5rem;

    @media only screen and (min-width: 1440px) {
        box-shadow: 0.06944444444444445vw 0.20833333333333334vw
            1.0416666666666667vw 0.06944444444444445vw rgba(110, 226, 159, 0.15);
        border-radius: 0.6944444444444444vw;
        padding: 0 0.5555555555555556vw;
    }

    a {
        text-decoration: none !important;
    }

    &.new-modal-style {
        justify-content: center;
        background-color: #fff;
        padding: 0;
        border: none;

        * * {
            color: #fff;
        }

        .modal-header {
            display: none;

            background-color: #e8e8e8;
            justify-content: center;
            border-top-left-radius: 0.6944444444444444vw;
            border-top-right-radius: 0.6944444444444444vw;

            .modal-title {
                font-family: Barlow;
                font-size: 19px;
                font-style: normal;
                font-weight: 700;
                line-height: 23px;
                letter-spacing: 0em;
                text-align: center;
                color: #5d5d5d;
                text-transform: uppercase;

                @media only screen and (min-width: 1440px) {
                    font-size: 1.3194444444444444vw;
                    line-height: 1.5972222222222223vw;
                }
            }
        }

        .modal-body {
            background-color: #273138;
            border-radius: 10px;
        }

        .box-wallet {
            min-height: 144px;
            margin-bottom: 0 !important;
            background: transparent;
            justify-content: center;
            align-items: center;

            @media only screen and (min-width: 1440px) {
                min-height: 10vw;
            }

            &:hover {
                background-color: #101a20;
            }
        }

        .close {
            display: none;
        }
    }
}
.modal-header {
    border-bottom: none !important;
    padding: 3.7% !important;
    .modal-title {
        font-family: Bungee;
        font-style: normal;
        font-weight: normal;
        text-align: center;
        font-size: 1.5vmax; //22px;
        line-height: 1.4vmax; //20px;
        color: $primary-4;
        margin: auto 0;

        @media only screen and (min-width: 1440px) {
            /* font-size: 25px;
      line-height: 24px; */
            font-size: 1.7361111111111112vw;
            line-height: 1.6666666666666667vw;
        }
    }
    .close {
        margin: auto 0;
        color: #ffffff;
        font-size: 1.9vmax; //30px;
        opacity: 1 !important;
        padding: 0 !important;
    }
}

@media screen and (min-width: 0px) and (max-width: 768px) {
    .form-control,
    .form-control:active,
    .form-control:focus,
    .form-control:disabled {
        border-radius: 12px;
        font-size: 12px;
        padding: 13.5px 20px;
        height: auto;
    }
    .admin-wlt-dtl {
        width: 22.5vw !important;
        margin-right: 0;
        .admin-adr-wlt {
            margin: 4px 0 !important;
            height: 14px !important;
            border-radius: 10px !important;
            padding: 0px 5px;
            font-size: 8px !important;
            line-height: 15px !important;
            margin-left: 5px !important;
        }
    }
    .box-onwallet-2 {
        .tle-box-1 {
            font-size: 14px;
            line-height: 18px;
        }
    }
    .box-onwallet {
        .title-box-1 {
            font-size: 16px;
            line-height: 22px;
        }
        .title-box-2 {
            font-size: 16px;
            line-height: 22px;
        }
        .subtitle-box {
            font-size: 12px;
            line-height: 22px;
        }
    }
    .box-wallet {
        border-radius: 6px;
        min-height: 50px;
        padding: 0 20px;
        .text-wallet {
            font-size: 16px;
            line-height: 22px;
        }
        .img-wallet {
            margin: auto 0;
        }
    }
    .txt-btm-wlt {
        font-size: 12px;
        line-height: 18px;
    }
    .modal-content {
        padding: 0 0.5rem;
    }
    .modal-header {
        .modal-title {
            font-size: 22px;
            line-height: 20px;
            margin: auto 0;
        }
        .close {
            font-size: 30px;
            opacity: 1 !important;
            padding: 0 !important;
        }
    }
    .modal-dialog {
        width: 350px !important;
        margin: 0.5rem auto !important;
    }
}
.connect-wallet__img {
    width: auto;
    height: auto;

    @media only screen and (min-width: 1440px) {
        height: 2.2916666666666665vw;
    }
}
</style>
